var _defs, _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG14(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.949,
    viewBox: "0 0 80.945 80.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.949,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.949,
    transform: "translate(0 0)",
    fill: "#0a96d9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.546,6.811V23.125H7.8V10.637H7.779l-1.925,2H5.829V9.771l2.527-2.96Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.869,18.338l2.455-6.717h.024v6.717Zm5.031,4.79V20.48h1.107V18.338H18.9V6.807H16.2L11.462,18.8V20.48H16.3v2.648Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.454,60.316a2.692,2.692,0,1,1,2.7-2.694,2.694,2.694,0,0,1-2.7,2.694m11.695-1.255c-1.019-1.376-7.6-9.766-16.825-9.766-8.011,0-16.581,7.267-16.581,7.267s-3.22-6.59-9.805-7.223c-.039,0-.08-.009-.124-.009h-.041a.269.269,0,0,0-.251.261.734.734,0,0,0,.1.241c.849,1.409,3.015,5.419,3.015,9.424s-2.179,8.039-3.02,9.441l-.057.09a.267.267,0,0,0-.041.139.262.262,0,0,0,.243.259l.071-.006a.284.284,0,0,0,.07-.006c6.6-.616,9.837-7.225,9.837-7.225s8.57,7.267,16.581,7.267c9.226,0,15.806-8.39,16.825-9.764.028-.037.051-.069.071-.094a.272.272,0,0,0,.021-.1.262.262,0,0,0-.021-.1c-.02-.028-.043-.061-.071-.095",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.73,33.526a.277.277,0,0,0-.051-.011.266.266,0,0,0-.264.267v1.836a.258.258,0,0,0,.077.19c4.453,3.87,8.67.244,9.646-.714a.237.237,0,0,1,.07-.074.264.264,0,0,1,.145-.048.257.257,0,0,1,.18.071.033.033,0,0,0,.013.011c5.03,4.8,10.305.912,11.4,0l.108-.1a.242.242,0,0,1,.1-.02.252.252,0,0,1,.105.02l.109.1c1.1.912,6.371,4.8,11.4,0,0,0,.008-.006.01-.011a.255.255,0,0,1,.179-.071.262.262,0,0,1,.146.048.274.274,0,0,1,.074.074c.975.958,5.187,4.584,9.645.714a.265.265,0,0,0,.076-.19V33.782a.263.263,0,0,0-.261-.267.3.3,0,0,0-.057.011c-.041.024-.084.046-.134.069a8.1,8.1,0,0,1-9.473-1.33c-.037-.034-.075-.068-.112-.107a.279.279,0,0,0-.113-.024.467.467,0,0,0-.079.012.3.3,0,0,0-.135.1c-1.149.876-6.424,4.447-11.121.065l-.069-.067a.3.3,0,0,0-.191-.079.279.279,0,0,0-.183.079l-.073.067c-4.7,4.382-9.976.811-11.124-.065a.289.289,0,0,0-.13-.1.548.548,0,0,0-.084-.012.288.288,0,0,0-.111.024,1.267,1.267,0,0,1-.113.107,8.1,8.1,0,0,1-9.472,1.33c-.049-.023-.094-.045-.136-.069",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.138,41.776a.286.286,0,0,1,.07-.073.278.278,0,0,1,.146-.05.258.258,0,0,1,.18.074s.008.008.012.011c5.029,4.8,10.305.909,11.4,0l.107-.1a.257.257,0,0,1,.1-.017.278.278,0,0,1,.106.017l.108.1c1.1.909,6.371,4.8,11.4,0l.009-.011a.253.253,0,0,1,.179-.074.263.263,0,0,1,.145.05.274.274,0,0,1,.075.073c.975.959,5.187,4.586,9.645.713A.264.264,0,0,0,61.9,42.3V40.462a.263.263,0,0,0-.263-.264.408.408,0,0,0-.057.011l-.134.067a8.109,8.109,0,0,1-9.473-1.329c-.036-.034-.074-.068-.112-.106a.227.227,0,0,0-.113-.026.168.168,0,0,0-.079.02.225.225,0,0,0-.134.1c-1.149.875-6.425,4.447-11.123.064l-.068-.068a.273.273,0,0,0-.191-.074.263.263,0,0,0-.184.074L39.9,39c-4.695,4.383-9.976.811-11.123-.064a.222.222,0,0,0-.131-.1.192.192,0,0,0-.084-.02.228.228,0,0,0-.11.026c-.036.038-.075.072-.114.106a8.108,8.108,0,0,1-9.472,1.329l-.135-.067a.433.433,0,0,0-.051-.011.264.264,0,0,0-.265.264V42.3a.259.259,0,0,0,.076.186c4.454,3.873,8.671.246,9.647-.713",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.84,6.779h1.112v5.707h1.327v.907H25.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(28.797 6.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.554,6.779h2.6v.907H31.666V9.579h1.112v.9H31.666v2.917H30.554Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.657,6.779h2.654v.907H34.769V9.579h1.1v.9h-1.1v2.01h1.542v.907H33.657Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,10.418v2.068h.488a.479.479,0,0,0,.547-.537v-.995c0-.351-.166-.536-.556-.536Zm0-.849h.391a.468.468,0,0,0,.526-.537V8.223a.468.468,0,0,0-.536-.537H39.5Zm-1.112-2.79H40c1.112,0,1.483.517,1.483,1.454v.673a.962.962,0,0,1-.664,1.053,1,1,0,0,1,.83,1.1v.878c0,.937-.42,1.454-1.532,1.454H38.389Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.127,6.779h2.654v.907H43.239V9.579h1.1v.9h-1.1v2.01h1.542v.907H42.127Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.454,6.779h1.112v5.707h1.327v.907H45.454Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.577,11.862V8.311c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.636,9.305l-.624,4.087H52.968L52.08,6.778h1.073l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01l.507-4.195h.936l-.858,6.614H55.3l-.653-4.087Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.233,19.014,27.609,23.1H26.565l-.888-6.614H26.75l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01l.507-4.195h.936L29.95,23.1H28.9l-.653-4.087Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.048,21h.888L32.5,18.351h-.01Zm-1.4,2.1L31.9,16.488H33.17L34.429,23.1H33.287l-.2-1.21H31.9l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.215,16.488h2.956v.907h-.917V23.1H35.132V17.395h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.689,16.488h2.653v.907H38.8v1.893h1.1v.9H38.8v2.01h1.541V23.1H37.689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05,17.4v2.058h.371a.481.481,0,0,0,.546-.546v-.975c0-.361-.165-.537-.546-.537Zm0,2.673V23.1H40.938V16.488h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3H43.094Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG14);
export default __webpack_public_path__ + "static/media/G14.dddc06b113ee18c287db9a454e59d7b3.svg";
export { ForwardRef as ReactComponent };